import API from "./API";
import axios from "axios";

const Sticker = {

    async postEvent(data){
        const url = API.url('/sticker/events');
        return await axios.post(url, data);
    },

}

export default Sticker;